import { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import BannerSection from "../../Components/BannerSection";
import FixturesAndResults from "../../Components/FixturesAndResults";
import axios from "axios";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Champions from "../../Components/Champions";
import useDeviceType from "../../Utiles/FindDevice";
import {
  fetchRoundPageCategory,
  fixtureOpen,
  updatePickMAtchWeek,
  updateV2Fixtures,
} from "../RoundToJoin/roundToJoin.slice";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BuyTokenPopUp from "../../popups/BuyTokenPopup";
import TokenRedeemPopUp from "../../popups/tokenRedeemPopUp";
import Dropdown from "../RoundToJoin/Dropdown";
import Navbar from "../RoundToJoin/navbar";
import LeagueList from "../RoundToJoin/LeagueList";
import pickDetailHeader from "../../Asserts/images/pickDetailHeader.svg";
import arrowBack from "../../Asserts/images/arrow_back.svg";
import { fixtures } from "./data";
import PickSummary from "./PickSummary";
import OtherPlayesPredictions from "./OtherPlayesPredictions";
import PickDetailFixtures from "./PickDetailFixtures";
import { baseURL } from "../../services/axiosConfig";
import { refreshTokenV2 } from "../../services/api";
import { fetchFixtures } from "./pickDetail.slice";

function PickDetail() {
  const { redeemPopup } = useSelector((state) => state.roundToJoin);
  const token = localStorage.getItem("access_token");
  const location = useLocation();
  const { myRound } = location.state || {};
  const pageCategory = useSelector((state) => {
    return state.roundToJoin.pageCategory;
  });
  const deviceType = useDeviceType();

  // States for navigation and UI
  const [selectedNav, setSelectedNav] = useState("Rounds");
  const [selectedSubNav, setSelectedSubNav] = useState(pageCategory);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [otherMenusOpen, setOtherMenusOpen] = useState(false);
  const [dropdownPos, setDropdownPos] = useState({});
  const [sportLeague, setSprotLeage] = useState({
    sport: {},
    league: {},
    roundState: {},
  });

  const [isOtherPlayerLoading, setIsOtherPlayerLoading] = useState(false);
  const [isPickFixturesLoading, setIsPickFixturesLoading] = useState(false);
  const [otherPlayerFilter, setOtherPlayerFilter] = useState(null);

  const pickDetailMatchWeek = useSelector(
    (state) => state.roundToJoin.pickDetailMatchWeek
  );

  const [isDifficultyRating, setIsDifficultyRating] = useState('left');

  const {
    page,
    sub,
    potId,
    matchWeeksId,
    seasonId,
    logo,
    soasonName,
    potValue,
    currency,
    status,
    round,
    pickId,
    matchWeeks,
    currentMatchWeek,
    totalPick,
    pickStatus,
    isTimeEnd,
    configuredLeagueId,
    btnColor,
    btnName
  } = location.state || {};

  const [selectedGame, setSelectedGame] = useState({
    sport: {},
    league: {},
    roundState: {},
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setSelectedSubNav(pageCategory);
  }, [pageCategory]);

  const profileBtnRef = useRef(null);

  // Navigation dropdown handling is now managed in the Navbar component
  useEffect(() => {
    if (dropdownOpen && profileBtnRef.current) {
      const rect = profileBtnRef.current.getBoundingClientRect();
      setDropdownPos({ right: 0 });
    }
  }, [dropdownOpen]);

  // round to join logics
  useEffect(() => { }, [selectedSubNav]);

  useEffect(() => {

    if (myRound) {
      dispatch(fetchRoundPageCategory("myRound"));
    } else if (status === "Completed" && !myRound) {
      dispatch(fetchRoundPageCategory("compleated"));
    } else {
      dispatch(fetchRoundPageCategory("Round To Join"));
    }
  }, [myRound]);

  useEffect(() => {
    if (currentMatchWeek) {
      dispatch(updatePickMAtchWeek(currentMatchWeek));
    }
  }, [currentMatchWeek || matchWeeks]);

  const [pickDetails, setPickDetails] = useState([
    {
      pickSummary: [],
      otherPlayers: [],
      fixture: [],
      allMatchWeek: [],
    },
  ]);

  async function fetchAllMatchWeek() {
    try {
      const token = localStorage.getItem("access_token");
      const res = await axios.get(
        `${baseURL}/pot/seasonmatchweeks?season=${seasonId}&pot_id=${potId}`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
          },
        }
      );
      return res.data.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        refreshTokenV2(dispatch);
      }
      console.log(error);
    }
  }

  async function fetchPickDetailFixture() {
    try {
      setIsPickFixturesLoading(true);
      const findMatchWeek =
        pickDetails?.allMatchWeek?.find(
          (ele) => ele.matchweek_number === Number(pickDetailMatchWeek)
        )?.id || matchWeeks;
      let res;
      if (btnName === "viewDetails") {
        res = await axios.get(
          `${baseURL}/pot/pickmatchpredictions/${findMatchWeek}?pot=${potId}`,
          {
            headers: {
              Authorization: `Bearer ${JSON.parse(token)}`,
            },
          }
        );
      } else {
        res = await axios.get(
          `${baseURL}/pot/pickmatchpredictions/${findMatchWeek}?pick=${pickId}`,
          {
            headers: {
              Authorization: `Bearer ${JSON.parse(token)}`,
            },
          }
        );
      }

      setIsPickFixturesLoading(false);
      setPickDetails((prev) => ({
        ...prev,
        fixture: res.data.data,
      }));
      dispatch(fetchFixtures(res.data.data));
    } catch (error) {
      if (error?.response?.status === 401) {
        refreshTokenV2(dispatch);
      }
      setIsPickFixturesLoading(false);
      console.log(error);
    }
  }

  useEffect(() => {
    fetchPickDetailFixture();
  }, [pickDetailMatchWeek || matchWeeks]);

  async function fetchOtherPlayerPrediction() {
    try {
      setIsOtherPlayerLoading(true);

      const token = localStorage.getItem("access_token");
      let url = `${baseURL}/pot/otherplayerpredictions/${potId}`;

      if (otherPlayerFilter !== null) {
        url += `?active=${otherPlayerFilter}`;
      }

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${JSON.parse(token)}`,
        },
      });

      setIsOtherPlayerLoading(false);
      return res.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        refreshTokenV2(dispatch);
      }
      setIsOtherPlayerLoading(false);
      console.error("Other Player Prediction Error:", error);
    }
  }

  useEffect(() => {
    async function fetchData() {
      try {
        const [otherPredictions, allMatchWeek] = await Promise.all([
          fetchOtherPlayerPrediction(),
          fetchAllMatchWeek(),
        ]);
        setPickDetails((prev) => {
          return {
            ...prev,
            otherPlayers: otherPredictions,
            allMatchWeek: allMatchWeek,
          };
        });
      } catch (e) {
        console.error("Fetching data failed", e);
      }
    }

    fetchData();
  }, [otherPlayerFilter]);

  return (
    <div className="font-interFont w-full bg-[#082642] min-h-screen border border-[#082642]">
      {redeemPopup && <TokenRedeemPopUp />}
      <Navbar
        setDropdownOpen={setDropdownOpen}
        dropdownOpen={dropdownOpen}
        dropdownPos={dropdownPos}
        selectedNav={selectedNav}
        setSelectedNav={setSelectedNav}
        setDropdownPos={setDropdownPos}
        otherMenusOpen={otherMenusOpen}
        setOtherMenusOpen={setOtherMenusOpen}
      />
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="pt-14 w-full h-full">
        <div className="w-full bg-gradient-to-r from-[#007FFF] to-[#00C05B] py-4 px-4 overflow-x-auto scrollbar-hide">
          {/* MOBILE HEADER - Optimized */}
          <div className="sm:hidden flex flex-col items-start w-full gap-1.5">
            <div className="flex items-center gap-2.5 w-full">
              <img
                src={arrowBack}
                className="h-4 w-4 cursor-pointer flex-shrink-0"
                alt="back"
                onClick={() => {
                  if (page) {
                    if (sub === "myRound") {
                      navigate(`${page}`, { state: { myRound: true } });
                    }
                    else if (sub === "compleated") {
                      navigate(`${page}`, { state: { myRound: false } });
                    } else {
                      navigate(`${page}`, { state: { myRound: false } });
                    }
                  }
                }}
              />
              <div className="bg-white rounded-full h-9 w-9 flex items-center justify-center flex-shrink-0">
                <img src={logo} className="h-6 w-6" alt="icon" />
              </div>
              <div className="flex flex-col ml-1 min-w-0 flex-1">
                <span className="text-white font-semibold text-[13px] leading-tight truncate">
                  {soasonName} -
                  <span className="text-white font-extrabold text-[13px] leading-tight ml-1">
                    <span className="font-semibold">$</span> {potValue}
                  </span>
                </span>
              </div>
            </div>

            {/* Second Row: Status badge & details */}
            <div className="flex items-center w-full gap-2 mt-0.5">
              {/* Status badge */}
              <div className={`block sm:hidden text-white `}>
                {" "}
                <span
                  className={`text-white ${pickStatus === "Active"
                    ? "bg-white"
                    : pickStatus === "Lost"
                      ? "bg-red-500"
                      : pickStatus === "Won"
                        ? "bg-green-500"
                        : pickStatus === "Jackpot"
                          ? "bg-green-500"
                          : "bg-green-500"
                    }  p-2 text-xs px-2 py-1 
                  rounded-full`}
                  style={{
                    backgroundColor: pickStatus === 'Lost' ? 'red' : 'green',
                    color: "white"
                  }}
                >
                  <span
                    className="h-2 w-2 bg-white rounded-full mr-1"
                    style={{
                      display: "inline-block",
                      backgroundColor: "white",
                      color: "white"
                    }}
                  ></span>
                  {pickStatus || status}
                </span>
                {
                  btnName === 'viewDetails' && <div className="mt-1">
                    <span
                      className={`text-white bg-red-500 p-2 text-xs px-3 py-1 
                    rounded-full flex items-center gap-1 font-semibold`}
                    >
                      <span
                        className="h-2 w-2 bg-white rounded-full mr-1"
                        style={{
                          display: "inline-block",
                          backgroundColor: "white",
                          color: "white"
                        }}
                      ></span>
                      Entry closed
                    </span>
                  </div>
                }

              </div>




              {/* IDs and picks - Vertically aligned columns */}
              <div className="flex flex-col text-white text-[10px] leading-tight min-w-0 flex-1">
                <div className="flex items-center">
                  <div className="flex-1">
                    <span className="truncate">Rnd ID : {round}</span>
                  </div>
                  {btnName !== "viewDetails" && <span className="text-white/60 mx-1">|</span>}
                  {btnName !== "viewDetails" && <div className="flex-1">
                    <span className="truncate">Pick ID : {pickId}</span>
                  </div>}
                </div>
                <div className="flex items-center mt-0.5">
                  <div className="flex-1">
                    <span className="truncate">
                      Match Week : {Number(currentMatchWeek)}
                    </span>
                  </div>
                  <span className="text-white/60 mx-1">|</span>
                  <div className="flex-1">
                    <span className="truncate">Total Picks : {totalPick}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
          {/* DESKTOP/TABLET - original layout */}
          <div className="hidden md:flex md:flex-col md:items-start lg:flex-row lg:justify-between items-start lg:items-center gap-4 sm:gap-2 px-3 min-w-min whitespace-nowrap">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4">
              <div className="flex items-center gap-2">
                <img
                  src={arrowBack}
                  style={{ cursor: "pointer" }}
                  className="h-5 w-5 sm:h-6 sm:w-6 cursor-pointer"
                  alt="back"
                  onClick={() => {
                    if (page) {
                      if (sub === "myRound") {
                        navigate(`${page}`, { state: { myRound: true } });
                      } else {
                        navigate(`${page}`, { state: { myRound: false } });
                      }
                    }
                  }}
                />
                <div className="bg-white rounded-full p-2 cursor-pointer">
                  <img
                    src={logo}
                    className="h-8 w-8 sm:h-10 sm:w-10"
                    alt="icon"
                  />
                </div>
                <div>
                  <p className="text-[15px] sm:text-[18px] font-semibold text-white">
                    {soasonName} - $ {potValue}
                  </p>
                  <div className="text-sm sm:text-base text-white sm:hidden">
                    {status}
                  </div>
                </div>
                <div className={`hidden sm:block text-white `}>
                  <span
                    className={`text-white ${pickStatus === "Active"
                      ? "bg-white"
                      : pickStatus === "Lost"
                        ? "bg-red-500"
                        : pickStatus === "Won"
                          ? "bg-green-500"
                          : pickStatus === "Jackpot"
                            ? "bg-green-500"
                            : "bg-green-500"
                      }  p-2 text-xs px-3 py-1 
                    rounded-full flex items-center gap-1 font-semibold`}
                    style={{
                      backgroundColor: pickStatus === 'Lost' ? 'red' : 'green',
                      color: "white"
                    }}
                  >
                    <span
                      className="h-2 w-2 bg-white rounded-full mr-1"
                      style={{
                        display: "inline-block",
                        backgroundColor: "white",
                        color: "white"
                      }}
                    ></span>
                    {pickStatus || status}
                  </span>
                </div>
                {
                  btnName === "viewDetails" && <div className={`hidden sm:block text-white `}>
                    <span
                      className={`text-white bg-red-500 p-2 text-xs px-3 py-1 
                    rounded-full flex items-center gap-1 font-semibold`}
                    >
                      <span
                        className="h-2 w-2 bg-white rounded-full mr-1"
                        style={{
                          display: "inline-block",
                          backgroundColor: "white",
                          color: "white"
                        }}
                      ></span>
                      Entry closed
                    </span>
                  </div>
                }

              </div>
            </div>
            <div className="flex flex-wrap sm:flex-nowrap sm:justify-between items-start sm:items-center gap-1 sm:gap-2 text-[14px] sm:text-[18px] font-semibold text-white">
              <p>Rnd ID : {round} |</p>
              {btnName !== "viewDetails" && <p>Pick ID : {pickId} |</p>}
              <p>Match Week : {Number(currentMatchWeek)} |</p>
              <p>Total Picks : {totalPick}</p>
            </div>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-4 m-[2%] items-stretch pt-10 lg:pt-2 pb-10 lg:pb-2">
          <PickDetailFixtures
            pickId={pickId}
            potId={potId}
            pickStatus={pickStatus}
            seasonId={seasonId}
            fixture={pickDetails.fixture}
            setPickDetails={setPickDetails}
            currentMatchWeek={currentMatchWeek}
            allMatchWeek={pickDetails.allMatchWeek}
            isTimeEnd={isTimeEnd}
            isPickFixturesLoading={isPickFixturesLoading}
            isDifficultyRating={isDifficultyRating}
            setIsDifficultyRating={setIsDifficultyRating}
            otherPlayersPrediction={pickDetails.otherPlayers}
            configuredLeagueId={configuredLeagueId}
            btnName={btnName}
          />
          <PickSummary
            pickDetails={pickDetails.pickSummary}
            seasonId={seasonId}
            currentMatchWeek={currentMatchWeek}
            allMatchWeek={pickDetails.allMatchWeek}
            potId={potId}
            matchWeeksId={matchWeeksId}
            matchWeeks={matchWeeks}
          />
          <OtherPlayesPredictions
            pickId={pickId}
            otherPlayersPrediction={pickDetails.otherPlayers}
            seasonId={seasonId}
            currentMatchWeek={currentMatchWeek}
            potId={potId}
            isOtherPlayerLoading={isOtherPlayerLoading}
            setOtherPlayerFilter={setOtherPlayerFilter}
            btnName={btnName}
          />
        </div>
        <style jsx>{`
          .scrollbar-hide::-webkit-scrollbar {
            display: none;
          }
          .scrollbar-hide {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
        `}</style>
      </div>
    </div>
  );
}

export default PickDetail;
